import React from 'react'
import { SvgIcon, makeStyles } from '@material-ui/core'

export const TickIcon = (props) => {
  const useStyles = makeStyles((theme) => ({
    customIcon: {
      fill: props?.fill,
      width: props?.width,
      height: props?.height,
    },
  }));

  const classes = useStyles();
  return (
    <SvgIcon {...props} className={classes.customIcon} viewBox="0 0 11 12">
      <path d="M3.55171 9.97028C3.23947 9.97041 2.94001 9.8463 2.71941 9.62533L0.20307 7.10992C-0.0676898 6.83907 -0.0676898 6.40003 0.20307 6.12919C0.473916 5.85843 0.912957 5.85843 1.1838 6.12919L3.55171 8.4971L9.8162 2.23261C10.087 1.96185 10.5261 1.96185 10.7969 2.23261C11.0677 2.50346 11.0677 2.9425 10.7969 3.21334L4.38402 9.62533C4.16341 9.8463 3.86396 9.97041 3.55171 9.97028Z"/>
    </SvgIcon>
  )
}
